import gql from 'graphql-tag';

export default gql`
  fragment CalendarPermissionsStatusFragment on CalendarPermissionsStatus {
    hasReadPermissions
    hasWritePermissions
    permissionsLastCheckedAt
  }
`;
